export default __webpack_public_path__ + "static/media/clock.73df6a3d.svg";